import React, { useEffect, useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Anchor, Instagram, Mail, MessageCircle } from 'lucide-react';
import { Button } from './ui';
import { FloatingActions } from './FloatingActions';
const WHATSAPP_URL = 'https://wa.me/5491122836110?text=' + encodeURIComponent('Hola! Me interesa el viaje a Fernando de Noronha 2026.');
const INSTAGRAM_URL = 'https://www.instagram.com/buceoynavegacion/';
const socials = [{
  name: 'WhatsApp',
  href: WHATSAPP_URL,
  external: true,
  Icon: MessageCircle
}, {
  name: 'Instagram',
  href: INSTAGRAM_URL,
  external: true,
  Icon: Instagram
}, {
  name: 'Email',
  href: 'mailto:info@buceoynavegacion.com',
  external: false,
  Icon: Mail
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`absolute top-0 left-0 right-0 z-50 bg-transparent py-7 transition-opacity duration-300 ${isScrolled ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} data-id="element-327" data-mp="1msyzluf2wnmq">
      <div className="container mx-auto px-6 flex items-start justify-between gap-4" data-id="element-328" data-mp="1wk3dsrwxk4gi">
        {/* Brand block */}
        <a href="#" className="flex flex-col group" data-id="element-329" data-mp="zu2omrsnflyo">
          <div data-id="element-330" data-mp="zvnomwxqfx3x">
            <h2 className="font-heading font-bold text-xl sm:text-2xl md:text-3xl leading-[1.05] tracking-[0.12em] text-noronha-text-heading uppercase" data-id="element-331" data-mp="13umnq0ws8zng">
              Buceo y
              <br data-id="element-332" data-mp="18w27lpn85049" />
              Navegación
            </h2>
            <div className="mt-3 flex flex-col gap-0.5 font-mono text-[10px] sm:text-xs tracking-[0.18em] text-noronha-emerald uppercase" data-id="element-333" data-mp="1dtvfcn46e26n">
              <span data-id="element-334" data-mp="2kbij8tk071vz">Escuela de Buceo</span>
              <span data-id="element-335" data-mp="2p7fzz0z6ia9a">Viajes Grupales</span>
              <span data-id="element-336" data-mp="2p6efy706qdff">Agencia de Turismo HC 26.614</span>
            </div>
          </div>
        </a>

        {/* Socials + CTA */}
        <div className="flex flex-col items-end gap-4 shrink-0" data-id="element-337" data-mp="1ul0mjl3xlf67">
          <div className="flex items-center gap-3" data-id="element-338" data-mp="1ukr027i3hq59">
            {socials.map(({
            name,
            href,
            external,
            Icon
          }) => <a key={name} href={href} aria-label={name} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center rounded-full border border-noronha-petroleum/60 text-noronha-text-heading hover:border-noronha-emerald hover:text-noronha-emerald hover:bg-noronha-emerald/10 transition-all duration-300" data-id="element-339" data-mp="29fx3qntpxcvf">
                <Icon className="w-4 h-4 sm:w-5 sm:h-5" strokeWidth={1.75} data-id="element-340" data-mp="y2up3yb6ixdw" />
              </a>)}
          </div>
          <Button variant="primary" className="hidden sm:inline-flex py-2.5 px-5 text-xs" data-id="element-341" data-mp="t2yjjumu2xw8">
            Reservar mi lugar
          </Button>
        </div>
      </div>
    </header>;
}
export function Footer() {
  return <footer className="bg-noronha-graphite border-t border-noronha-petroleum/30 pt-20 pb-10" data-id="element-342" data-mp="39jwl47n2u3m2">
      <div className="container mx-auto px-6" data-id="element-343" data-mp="2urchl5w0lu43">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-344" data-mp="2ztbmwlbbf13o">
          <div className="md:col-span-2" data-id="element-345" data-mp="3ni4c7yxfmapb">
            <a href="#" className="flex items-center gap-2 mb-6" data-id="element-346" data-mp="3nj5vursik5in">
              <Anchor className="w-6 h-6 text-noronha-emerald" data-id="element-347" data-mp="3shh8196a6s41" />
              <span className="font-heading font-semibold text-xl text-noronha-text-heading" data-id="element-348" data-mp="3selb9o6669h6">
                Buceo y Navegación
              </span>
            </a>
            <p className="text-noronha-text-body max-w-sm" data-id="element-349" data-mp="3ihgopn8ewbzu">
              Expediciones de buceo premium en los destinos más exclusivos del
              planeta. Naturaleza, aventura y excelencia.
            </p>
          </div>
          <div data-id="element-350" data-mp="271i72uz64hn0">
            <h4 className="font-mono text-sm tracking-widest text-noronha-gold mb-6 uppercase" data-id="element-351" data-mp="2nar43c1hkfde">
              Destinos
            </h4>
            <ul className="flex flex-col gap-3 text-noronha-text-body" data-id="element-352" data-mp="2iizlposhhfyc">
              <li data-id="element-353" data-mp="2dkoab9mjixe0">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-354" data-mp="2dk6a61wrbz0t">
                  Bonaire
                </a>
              </li>
              <li data-id="element-355" data-mp="368k68c4acl9q">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-356" data-mp="3693e10081ta1">
                  Fernando de Noronha
                </a>
              </li>
              <li data-id="element-357" data-mp="2w9mc8to3bzjc">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-358" data-mp="2wda1hgmi5zs9">
                  Galápagos
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-359" data-mp="1gufbdqhfnpp7">
            <h4 className="font-mono text-sm tracking-widest text-noronha-gold mb-6 uppercase" data-id="element-360" data-mp="1gtvw6hj63fev">
              Contacto
            </h4>
            <ul className="flex flex-col gap-3 text-noronha-text-body" data-id="element-361" data-mp="3sg7g49mqjwc6">
              <li data-id="element-362" data-mp="erdffy3smbq">
                <a href="mailto:info@buceoynavegacion.com" className="hover:text-noronha-emerald transition-colors" data-id="element-363" data-mp="c5axuq2kx0d">
                  info@buceoynavegacion.com
                </a>
              </li>
              <li data-id="element-364" data-mp="f3xezakeyoms">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-365" data-mp="f2m8v43hx4si">
                  WhatsApp
                </a>
              </li>
              <li data-id="element-366" data-mp="o4byc4dthtnn">
                <a href="#" className="hover:text-noronha-emerald transition-colors" data-id="element-367" data-mp="o1pqe3n0lc4w">
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-noronha-petroleum/30 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-noronha-text-body/60" data-id="element-368" data-mp="2utgvxpo97roy">
          <p data-id="element-369" data-mp="3t62wlbvy7f1f">
            © {new Date().getFullYear()} Buceo y Navegación. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6" data-id="element-370" data-mp="b0q6khzsnm26">
            <a href="#" className="hover:text-noronha-text-heading transition-colors" data-id="element-371" data-mp="b1rlwynueupp">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-noronha-text-heading transition-colors" data-id="element-372" data-mp="kxcpv2ch2523">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen bg-noronha-volcanic text-noronha-text-body font-sans selection:bg-noronha-emerald/30 selection:text-noronha-text-heading" data-id="element-373" data-mp="pq5tto0499d4">
      <Navbar data-id="element-374" data-mp="yqu01wj9q5fg" />
      <main data-id="element-375" data-mp="yrdh7b13gpsf">{children}</main>
      <FloatingActions data-id="element-376" data-mp="yny1c5zljcpy" />
    </div>;
}